import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
@Component({
  selector: 'app-barra-navegacion',
  templateUrl: './barra-navegacion.component.html',
  styleUrls: ['./barra-navegacion.component.scss']
})
export class BarraNavegacionComponent {
  nombreWeb = 'Trazabilidad - Biotechsa';
  logo = "/assets/Logo-Biotechsa.png";

  constructor(private router: Router, public auth: AuthService) { }

  onLogin(): void {
    this.router.navigate(['/login']);
  }

  onLogout(): void {
    this.auth.setSessionOut();
    this.router.navigate(['/login']);
  }


}
